import { takeLatest } from 'redux-saga/effects';
import {
	getUserFarmersSuccess, getUserFarmersFail,
	getUserFarmsSuccess, getUserFarmsFail,
	getAnimalConditionsSuccess, getAnimalConditionsFail,
} from './dynamicListState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/admin');
const optionService = createCrudService('api/v1/services/options');

function* getUserFarmers(data) {	
	yield doCrudCall(
		() => crudService.doGetRequest('user-details', data.payload), 
		getUserFarmersSuccess, 
		getUserFarmersFail);
}

function* getUserFarms(data) {	
	yield doCrudCall(
		() => crudService.doGetRequest(`farm-parcels`, data.payload), 
		getUserFarmsSuccess, 
		getUserFarmsFail);
}

function* getAnimalConditions(data) {	
	yield doCrudCall(
		() => optionService.doGetRequest(`farm-animal-conditions`, data.payload), 
		getAnimalConditionsSuccess, 
		getAnimalConditionsFail);
}

function* dynamicListSaga() {
  yield takeLatest('dynamicList/getUserFarmers', getUserFarmers);
  yield takeLatest('dynamicList/getUserFarms', getUserFarms);
  yield takeLatest('dynamicList/getAnimalConditions', getAnimalConditions);
}

export default dynamicListSaga;
